import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { HeroImageRight } from '#marketing/components/HeroImageRight.jsx';
import { HomeMarketingSections } from '#marketing/components/HomeMarketingSections.jsx';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useTranslation } from 'react-i18next';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';

/** @param {{ matches: Array<{ id?: string, pathname?: string, data?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'home', pagePath: '/' });
}

export default function Home() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();

  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://pachub.ca/#organization',
    name: 'PAC Hub',
    url: 'https://pachub.ca',
    logo: 'https://pachub.ca/og-image.png',
    description: t('marketing.jsonLd.organizationDescription'),
    sameAs: ['https://x.com/pachub_hq', 'https://www.linkedin.com/company/pachub'],
    parentOrganization: {
      '@type': 'Organization',
      '@id': 'https://brightestcircle.ca/#organization',
      name: 'Brightest Circle',
      url: 'https://brightestcircle.ca',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        email: 'support@pachub.ca',
        contactType: 'customer support',
        url: `https://pachub.ca${localePath(locale, '/contact')}`,
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
      <HeroImageRight />
      <HomeMarketingSections />
    </>
  );
}
